module.exports = __webpack_public_path__ + "static/media/Beauty-Angel.21086684.png";